module.exports = __webpack_public_path__ + "static/img/index.2f321e7.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newIndex/index.webp
// module id = qTn1
// module chunks = 68